// Public browser-side settings only. Never put secret API keys here.
export const CONTACT_ENDPOINT = 'https://formsubmit.co/ajax/koltora.app@gmail.com';
export const CONTACT_EMAIL = 'Koltora.app@gmail.com';
// Path of the partnerships page; App.tsx routes it to the promo site as well as "/".
export const PROMO_EDUCATION_PATH = '/education';
export const HEBCAL_ORIGIN = 'https://www.hebcal.com';

// Brand video: Hebrew for Hebrew-language visitors, English for everyone else.
export const BRAND_VIDEO_HE = '/assets/promo/brand-video.mp4';
export const BRAND_VIDEO_EN = 'https://koltorah.app/audio/en_video_promo_1.mp4';

export interface PromoLanguageFormat {
  /** Intl locale used for dates and month names. */
  locale: string;
  /** Hebcal `lg` code for parasha names (Hebcal has no Swedish or Italian). */
  hebcal: string;
}

const LANGUAGE_FORMATS: Record<string, PromoLanguageFormat> = {
  he: { locale: 'he-IL', hebcal: 'he' },
  en: { locale: 'en-US', hebcal: 'en' },
  fr: { locale: 'fr-FR', hebcal: 'fr' },
  es: { locale: 'es-ES', hebcal: 'es' },
  sv: { locale: 'sv-SE', hebcal: 'en' },
  it: { locale: 'it-IT', hebcal: 'en' },
};

export const getLanguageFormat = (language: string | undefined): PromoLanguageFormat =>
  LANGUAGE_FORMATS[(language ?? 'he').slice(0, 2)] ?? LANGUAGE_FORMATS.he;
